import React, { useEffect, useState } from 'react';
import { BannerWrapper, Wrapper } from './styled';
import Layout from '../../components/Layout';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Pagination from '../../components/Pagination';
import {
	GetAuthors,
	GetPosts,
	GetSeriesNum,
	GetTags,
} from '../../service/blog';
import {
	SkeletonBanner,
	SkeletonList,
	SkeletonListRight,
	SkeletonMoBanner,
	SkeletonSeriesWrap,
} from '../../components/Skeleton';
import { useRecoilState, useRecoilValue } from 'recoil';
import { seriresAtom, seriresNumAtom, shuffleAtom } from '../../atom/taxonomy';

const Pocketlist = () => {
	const params = useParams();
	const [paged, setPaged] = useState(1);
	const postsPerPage = 8;
	const [items, setItems] = useState([]);
	const [s, setS] = useState(params?.keyword);
	const nav = useNavigate();
	const [total, setTotal] = useState(0);
	const [maxPaged, setMaxPaged] = useState(1);
	const [seriesNum, setSeriesNum] = useRecoilState(seriresNumAtom);
	const [shuffle, setShuffle] = useRecoilState(shuffleAtom);
	const series = useRecoilValue(seriresAtom);

	function shuffleArray(array) {
		const shuffledArray = [...array]; // Create a copy of the original array
		for (let i = shuffledArray.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffledArray[i], shuffledArray[j]] = [
				shuffledArray[j],
				shuffledArray[i],
			];
		}
		return shuffledArray;
	}

	const [reporter, setReporter] = useState([]);
	const [author, setAuthor] = useState([]);

	useEffect(() => {
		GetAuthors({})
			.then((res) => {
				console.log(res);
				if (res.data.code == 200) {
					setReporter(res.data.body.reporter);
					setFilteredArray(res.data.body.reporter);
					setAuthor(res.data.body.author);
					setFilteredArray2(res.data.body.author);
				} else {
					setItems(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	const [tags, setTags] = useState([]);
	useEffect(() => {
		GetTags({})
			.then((res) => {
				if (res.data.code == 200) {
					setTags(res.data.body.result);
				} else {
					setTags(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	const [pocket, setPocket] = useState([]);

	useEffect(() => {
		const shuffledObjects = shuffleArray(shuffle);
		setPocket(shuffleArray(seriesNum));
		console.log(77, shuffledObjects);
		setShuffle(shuffledObjects);
		GetSeriesNum({})
			.then((res) => {
				console.log(res);

				const sortedObjects = [...res.data.body.array]; // Create a copy of the array
				sortedObjects.sort((a, b) => b.value - a.value); // Sort by 'count' in ascending order

				console.log(123, sortedObjects);
				setSeriesNum(sortedObjects);
			})
			.catch((err) => {
				console.log(err);
			});
	}, []);

	const [filteredArray, setFilteredArray] = useState([]);
	const [filteredArray2, setFilteredArray2] = useState([]);

	const handleInputChange = (e) => {
		const text = e.target.value;
		setS(text);

		const filtered = reporter.filter(
			(item) =>
				item?.user_name?.includes(text) || item?.user_department?.includes(text)
		);
		setFilteredArray(filtered);

		const filtered2 = author.filter(
			(item) =>
				item?.user_name?.includes(text) || item?.user_department?.includes(text)
		);
		setFilteredArray2(filtered2);
	};

	return (
		<Layout>
			<Wrapper>
				<div className="flex-wrapper">
					<div className="left">
						<div className="input-box">
							<img src="/images/icon-search01.svg" alt="" />
							<input
								onChange={handleInputChange}
								type="text"
								value={s}
								placeholder="검색어를 입력하세요."
							/>
						</div>
						<div>
							{0 ? (
								<>
									<div className="result">
										<div className="result-box">
											<p>
												검색 결과가 없어요
												<br /> 다른 키워드를 검색해보세요!
											</p>
										</div>
									</div>
								</>
							) : (
								<>
									<div className="total-box">
										<p>
											총{' '}
											<span>
												{filteredArray?.length + filteredArray2?.length}
											</span>
											개의 프로필이 있습니다.
										</p>
									</div>
									<div className="press-wrap">
										<h1>기자단</h1>
										<div className="press-list">
											{filteredArray?.length
												? filteredArray.map((item, key) => (
														<a
															href={`/author/${item?.ID}`}
															className="box"
															key={key}
														>
															<div className="flex">
																<div className="press-left">
																	<div
																		className="press"
																		style={{
																			backgroundImage: `url(${item?.user_avatar_url})`,
																		}}
																	></div>
																	<div>
																		<p className="name">
																			{item?.user_name}
																			<img
																				src="/images/icon-pocket-check.svg"
																				alt=""
																			/>
																		</p>
																		<span>{item?.user_department}</span>
																	</div>
																</div>
																<div className="press-right">
																	<div className="writing-article">
																		<p>작성아티클</p>
																		<span>{item?.count}</span>
																	</div>
																</div>
															</div>
														</a>
												  ))
												: null}
										</div>
									</div>
									<div className="bold-line"></div>
									<div className="press-wrap">
										<h1>필진</h1>
										<div className="press-list">
											{filteredArray2?.length
												? filteredArray2.map((item, key) => (
														<a
															href={`/author/${item?.ID}`}
															className="box"
															key={key}
														>
															<div className="flex">
																<div className="press-left">
																	<div
																		className="press"
																		style={{
																			backgroundImage: `url(${item?.user_avatar_url})`,
																		}}
																	></div>
																	<div>
																		<p className="name">
																			{item?.user_name}
																			<img
																				src="/images/icon-pocket-check.svg"
																				alt=""
																			/>
																		</p>
																		<span>{item?.user_department}</span>
																	</div>
																</div>
																<div className="press-right">
																	<div className="writing-article">
																		<p>작성아티클</p>
																		<span>{item?.count}</span>
																	</div>
																</div>
															</div>
														</a>
												  ))
												: null}
										</div>
									</div>
								</>
							)}
						</div>
					</div>

					<div className="mo-banner-wrap">
						{1 ? (
							<div
								className="mo-banner"
								style={{ backgroundImage: `url(/images/mo-banner.png)` }}
							>
								<p className="title">
									새로운 금융IT 세상을 만들어갈 인재를 모십니다.
								</p>
								<a href="https://kbds.career.greetinghr.com/" target="_blank">
									<span>
										채용공고 보러가기
										<img src="/images/icon-banner-more.svg" alt="" />
									</span>
								</a>
							</div>
						) : (
							<SkeletonMoBanner />
						)}
						<div className="line"></div>
					</div>
					{pocket?.length ? (
						<div className="right">
							<div className="series">
								<h3>추천 포켓</h3>
								<div className="series-list">
									{pocket?.length ? (
										pocket.slice(0, 3).map((item, key) => (
											<div className="list" key={key}>
												<Link to={`/blog/series/${item.key}`}>
													<div
														className="seriesimg"
														style={{
															backgroundImage: `url(${shuffle[key]?.moThumbnail})`,
														}}
													></div>
													<div className="text-box">
														<h4>{item?.title}</h4>
														<p>게시글 {item?.value}개</p>
													</div>
												</Link>
											</div>
										))
									) : (
										<></>
									)}
								</div>
							</div>
							<div className="tag">
								<h3>최근 가장 인기있는 태그</h3>
								<ul>
									{tags.map((item, key) => (
										<Link to={`/tag/${item?.value?.name}`}>
											<li key={key}>#{item?.value?.name}</li>
										</Link>
									))}
								</ul>
							</div>
						</div>
					) : (
						<SkeletonSeriesWrap />
					)}
				</div>

				<BannerWrapper>
					{1 ? (
						<div
							className="banner"
							style={{ backgroundImage: `url(/images/banner-img02.png)` }}
						>
							<p className="title">
								새로운 금융IT 세상을 만들어갈 인재를 모십니다.
							</p>
							<a href="https://kbds.career.greetinghr.com/" target="_blank">
								<span>
									채용공고 보러가기
									<img src="/images/icon-banner-more.svg" alt="" />
								</span>
							</a>
						</div>
					) : (
						<SkeletonBanner />
					)}
				</BannerWrapper>
			</Wrapper>
		</Layout>
	);
};

export default Pocketlist;
